// extracted by mini-css-extract-plugin
export default {"content":"HostCardOrderCard_content__T4qBC","eyebrow":"HostCardOrderCard_eyebrow__iTqYH","title":"HostCardOrderCard_title__ydcII","action":"HostCardOrderCard_action__yVimB"};